import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { AppState } from 'src/app/store'

export interface CompensationState {
  step: number,
  projectSelected: object,
  amount: string,
  email: string,
  first_name: string,
  last_name: string,
  currency_token: string,
  offset_reason: string,
  initials: string
}

const initialState: CompensationState = {
  step: 0,
  projectSelected: null,
  amount: '',
  email: '',
  first_name: '',
  last_name: '',
  currency_token: 'EUR',
  offset_reason: '',
  initials: ''
}

export const compensationSlice = createSlice({
  name: 'compensation',
  initialState,
  reducers: {
    setAmount: (state, action: PayloadAction<string>) => {
      state.amount = action.payload
    },
    setCurrency: (state, action: PayloadAction<string>) => {
      state.currency_token = action.payload
    },
    setStep: (state, action: PayloadAction<number>) => {
      state.step = action.payload
    },
  }
})

export const { setAmount, setCurrency, setStep } = compensationSlice.actions

export const selectAmount = (state: AppState) => state.compensation.amount
export const selectCurrencyToken = (state: AppState) => state.compensation.currency_token
export const selectStep = (state: AppState) => state.compensation.step

export default compensationSlice.reducer
